import type { MediaSwiperProps } from '@/core/features/swiper/media-swiper/media-swiper-types';
import type { SwiperCoreType } from '@/core/features/swiper/swiper-wrapper/swiper-types';

import React from 'react';

import { SwiperWrapper } from '@/core/features';
import MediaElementSwitch from '@/core/features/swiper/media-swiper/media-element-switch';
import { isVideo } from '@/core/features/video/video-service';

export default function MediaSwiper(props: MediaSwiperProps) {
    const { swiperOptions } = props;
    const { initialSlide = 0 } = swiperOptions;

    const [activeSwiperSlideIndex, setActiveSwiperSlideIndex] = React.useState(initialSlide);

    const _onSlideChange = (swiper: SwiperCoreType) => {
        setActiveSwiperSlideIndex(swiper.realIndex);
        return swiperOptions.onSlideChange?.(swiper);
    };

    const onResize = (swiper: SwiperCoreType) => {
        if (!swiper.zoom) {
            return;
        }
        swiper.zoom.out();
    };

    return (
        <SwiperWrapper
            debugName={swiperOptions.debugName}
            disableLazyLoading={swiperOptions.disableLazyLoading}
            initialSlide={initialSlide}
            loop={swiperOptions.loop}
            navigation={swiperOptions.navigation}
            onNavigationNext={swiperOptions.onNavigationNext}
            onNavigationPrev={swiperOptions.onNavigationPrev}
            onResize={onResize}
            onSlideChange={_onSlideChange}
            onSwiper={swiperOptions.onSwiper}
            slideElementType={swiperOptions.slideElementType}
            slidesPerView={swiperOptions.slidesPerView}
            swiperModuleType={swiperOptions.swiperModuleType}
            swiperNavigation={swiperOptions.swiperNavigation}
            swiperSlideProps={{ className: swiperOptions.slideClassName }}
        >
            {props.items.map((item, index) => {
                const image = isVideo(item) ? item.poster : item;

                return (
                    <MediaElementSwitch
                        hasSmallOverlay={props.hasSmallOverlay}
                        imageOptions={props.imageOptions}
                        index={index}
                        item={item}
                        key={`${image.imageUrl}-${index}`}
                        swiperOptions={{ ...props.swiperOptions, activeSwiperSlideIndex }}
                    />
                );
            })}
        </SwiperWrapper>
    );
}
